<template>
    <b-dropdown :text="`${prefix}${getText(value)}`" toggle-class="caret" v-bind="$attrs" right v-on="$listeners">
        <template v-for="item in items">
            <b-dropdown-item :key="`key-${item}`" :active="item === value" @click="$emit('input', item)">{{ getText(item) }}</b-dropdown-item>
        </template>
    </b-dropdown>
</template>

<script>
    export default {
        name: 'DropdownFilter',
        props: {
            value: {
                type: [String, Number, Boolean],
                default: null,
                validator: val => val === null || val === true || val === false || typeof val === 'string' || typeof val === 'number',
            },
            items: {
                type: Array,
                required: true,
            },
            prefix: {
                type: String,
                default: '',
            },
            formatter: {
                type: Function,
                default: null,
            },
        },
        methods: {
            getText(value) {
                if (typeof this.formatter === 'function') {
                    return this.formatter(value);
                }
                return this.$tx(`filterItem.${value}`, value);
            },
        },
    };
</script>

<i18n lang="json" locale="pl" scope="local">
{
    "filterItem": {
        "amount": "Suma sprzedaży",
        "quantity": "Liczba [sztuk]",
        "orders": "Transakcje",
        "impressions": "Wyświetlenia ofert",
        "widget_impressions": "Wyświetlenia",
        "clicks": "Kliknięcia",
        "ctr": "CTR",
        "cr": "CR",
        "summary": "Suma",
        "percentDiff": "Zmiana %",
        "averageDesc": "Średnia % malejąco",
        "averageAsc": "Średnia % rosnąco",
        "changeDesc": "Zmiana % (do poprzedniego zakresu) malejąco",
        "changeAsc": "Zmiana % (do poprzedniego zakresu) rosnąco",
        "10": "10",
        "20": "20",
        "50": "50",
        "null": "Wszystkie",
        "day": "Dzienny",
        "month": "Miesięczny",
        "quarter": "Kwartalny",
        "year": "Roczny",
        "all": "Wszystkie"
    }
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "filterItem": {
        "amount": "Sum of sales",
        "quantity": "Number [pieces]",
        "orders": "Transactions",
        "impressions": "Offers display",
        "widget_impressions": "Impressions",
        "clicks": "Clicks",
        "ctr": "CTR",
        "cr": "CR",
        "summary": "Total",
        "percentDiff": "Change %",
        "averageDesc": "Average % descending",
        "averageAsc": "Average % ascending",
        "changeDesc": "Change % (to previous range) descending",
        "changeAsc": "Change % (to previous range) ascending",
        "10": "10",
        "20": "20",
        "50": "50",
        "null": "All",
        "day": "Daily",
        "month": "Monthly",
        "quarter": "Quarterly",
        "year": "Annual",
        "all": "All"
    }
}
</i18n>
